import {createReducer, on} from '@ngrx/store';
import * as StockHistoryActions from './stock-history.actions';
import {IGlobalError} from '../../../shared/shared-components/components/global-error-display/models/global-error';
import {IStockHistoryEvent, IStockHistoryItemOrigin, sortStockHistoryEventsByCode} from '../models/stock-history-interfaces';

export interface IStockHistoryState {
  currentStoreId: string | null;
  errors: IGlobalError[];
  events: IStockHistoryEvent[];
  hasMore: boolean;
  isLoading: boolean;
  isModalOpen: boolean;
  itemCodes: string[];
  itemOrigins: IStockHistoryItemOrigin[];
  lastDocumentId: string | null;
  queryEpoch: number;
  selectedField: string;
}

export const initialStockHistoryState: IStockHistoryState = {
  currentStoreId: null,
  errors: [],
  events: [],
  hasMore: true,
  isLoading: false,
  isModalOpen: false,
  itemCodes: [],
  itemOrigins: [],
  lastDocumentId: null,
  queryEpoch: 0,
  selectedField: 'All',
};

export const stockHistoryReducer = createReducer(
  structuredClone(initialStockHistoryState),
  on(StockHistoryActions.loadStockHistoryFirstPage, (state, {storeId, itemCodes, field}): IStockHistoryState => ({
    ...state,
    isLoading: true,
    currentStoreId: storeId,
    itemCodes: itemCodes ?? [],
    selectedField: field || 'All',
  })),
  on(StockHistoryActions.loadStockHistoryNextPage, (state): IStockHistoryState => ({
    ...state,
    isLoading: true,
  })),
  on(StockHistoryActions.loadStockHistorySuccess,
    (state, {events, lastDocumentId, hasMore, isFirstPage}): IStockHistoryState => ({
      ...state,
      isLoading: false,
      events: sortStockHistoryEventsByCode(isFirstPage
        ? events
        : [...state.events, ...events]),
      lastDocumentId,
      hasMore,
    }),
  ),
  on(StockHistoryActions.loadStockHistoryFailure, (state): IStockHistoryState => ({
    ...state,
    isLoading: false,
  })),
  on(StockHistoryActions.stockHistorySetStoreContext, (state, {storeId}): IStockHistoryState => ({
    ...state,
    currentStoreId: storeId,
  })),
  on(StockHistoryActions.updateStockHistorySearchTerm, (state, {itemCodes, field}): IStockHistoryState => ({
    ...state,
    itemCodes,
    itemOrigins: [],
    queryEpoch: state.queryEpoch + 1,
    selectedField: field || 'All',
  })),
  on(StockHistoryActions.loadStockHistoryItemOriginsSuccess, (state, {itemOrigins}): IStockHistoryState => ({
    ...state,
    itemOrigins,
  })),
  on(StockHistoryActions.resetStockHistoryState, () => ({
    ...initialStockHistoryState,
  })),
  on(StockHistoryActions.clearStockHistoryData, (state) => ({
    ...state,
    events: [],
    isLoading: true,
    queryEpoch: state.queryEpoch + 1,
  })),
  on(StockHistoryActions.openStockHistoryModal, (state): IStockHistoryState => ({
    ...state,
    isModalOpen: true,
    events: [],
    itemCodes: [],
    hasMore: true,
    isLoading: false,
    lastDocumentId: null,
    selectedField: 'All',
  })),
  on(StockHistoryActions.closeStockHistoryModal, (state): IStockHistoryState => ({
    ...state,
    isModalOpen: false,
  })),
);
